const _ = require('underscore/underscore-min');
const Utils = require('core-helpers/utils.js');
const Tracking = require('tracking/tracking-controller.js');
const CurrentUser = require('user/current-user-service.js');
const SharedDataService = require('data/shared-data-service.js');
const eCommerceService = require('core-services/ecommerce-origin-service.js');

(function(root, doc, undefined) {

    'use strict';

    const isPremiumAccess = () => {
        return doc.body.getAttribute('data-page-identifier') === 'premium';
    };

    const getCurrentLanguage = () => {
        return document.documentElement.lang || '';
    };

    const onUserSuccess = (user) => {
        return user;
    };

    const onUserError = () => {
        return null;
    };

    const sendEvent = (user) => {

        let data = {
            paywall_locale: getCurrentLanguage()
        };

        if (user) {
            data.paywall_country_code = user.country_code;
            data.paywall_cohort = user.country_code + '_normal';
        }

        const origin = eCommerceService.retrieve();
        if(origin){
            data.ecommerce_origin = origin;
        }
        
        Tracking.send('PAGE_VIEW_PREMIUM', data);

    };

    /**
     * We store the current page view.
     * This will be used to send an event from the webapp
     * if the user has seen or not the /premium page.
     * Backend will then use that to add a discount or not
     * the next time user will see that page.
     */
    const storePageView = () => {
        SharedDataService.storePremiumPageView();
    };

    const clickHandler = function() {
        const position = this.getAttribute('data-position');
        if (position) {
            Tracking.send('PAYWALL_SEEPLANS_CLICKED', {
                position: position
            });
        }
    };

    const attachTracking = () => {
        Utils.getElementsByClass('js-tracking').forEach((element) => {
            element.addEventListener('click', clickHandler);
        });
    };

    const init = () => {

        if (!isPremiumAccess()) {
            return false;
        }

        /**
         * If user is available, add extra datas, if not it means user is not recognize
         * and we will send the minimum datas we can find.
         */
        CurrentUser.get().then(onUserSuccess, onUserError).then(sendEvent).done();

        // Store current page view
        storePageView();

        // Attach buttons events
        attachTracking();

    };

    /**
     * Private vars
     */
    const filename = 'tracking-premium.js';

    init();

})(window, document);
